<template>
  <div class="user-about-cont">
    <div class="user-about">
      <div class="about-cont-p1-title">We Are Hiring！</div>
      <div class="about-cont-p2-title">In-campus Summer Intern</div>
      <div class="about-cont-li">
        <div class="about-cont-title">Job brief：</div>
        <div class="about-cont-main">
          <div class="about-cont-main">
            Covey Campus is a newly launched start-up platform. We serve to
            offer university students a neutral and trustable community to share
            their unique talents while they make side income in the meantime.
          </div>
          <div class="about-cont-main">
            Our position of Summer Intern - Business Development (BD) is a
            managerial role. We are looking for someone who can help the newly
            launched Covey platform acquire more new registered users as quickly
            as possible. At the same time, he or she will need to reach out and
            built cooperation with major campus clubs and student unions and
            bring them online to the Covey platform. Besides, our BD will need
            to plan and encourage users and societies to provide courses, share
            their talents on the Covey platform, and promote the healthy
            development of the platform.
          </div>
        </div>
      </div>
      <div class="about-cont-li">
        <div class="about-cont-title">Responsibilities：</div>
        <div class="about-cont-main">
          <ul>
            <li v-for="item in responsibilities">{{ item.text }}</li>
          </ul>
        </div>
      </div>
      <div class="about-cont-li">
        <div class="about-cont-title">Requirements:</div>
        <div class="about-cont-main">
          <ul>
            <li v-for="item in responsibilities">{{ item.text }}</li>
          </ul>
        </div>
      </div>
      <div class="about-cont-li">
        <div class="about-cont-title">Chance to join the founders' team!</div>
        <div class="about-cont-main">
          <div class="about-cont-main">
            As a newly founded start-up company, here we are not only looking
            for a Summer Intern, but also our potential future partner. If you
            have a passion to improve the life quality of people and making
            changes in this world, please don't hesitate to
            <a href="/#/about">contact us</a>!
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      responsibilities: [
        {
          text: "Contact school clubs and student unions for cooperation, invite members to join the Covey platform to create club accounts; encourage clubs and club members to use Covey for event notification and online courses to raise funds and expand the influence of the clubs.",
        },
        {
          text: "Promote the Covey platform among the campus students, expand the number of registered users of Covey, and encourage students to share knowledge and publish courses on Covey.",
        },
        {
          text: "Recruit and form your campus promotion team, and manage and organize the work of the promotion team.",
        },
        {
          text: "Regularly report to supervisor to discuss and design business development plan.",
        },
      ],
      requirements: [
        {
          text: "Current students or have graduated for less than 1 year.",
        },
        {
          text: "Proven experience as a group/club leader.",
        },
        {
          text: "Experience in organizing activities and promotions.",
        },
        {
          text: "Organizational and leadership abilities.",
        },
        {
          text: "Problem-solving aptitude.",
        },
        {
          text: "Creative thinking skills.",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
@import "~@/utils/vw.scss";
.user-about-cont {
  width: 100%;
  padding: 24px 16px;
  box-sizing: border-box;
}
.user-about {
  // width: 100%;
  //   max-width: 1336px;
  // height: vw(625);
  background: #fff;
//   margin-top: 60px;
  // text-align: center;
  // border-radius: 24px;
  box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.04);
  padding: 24px;
  box-sizing: border-box;
  .about-cont-p1-title {
    color: #3b3844;
    font-size: 26px;
    font-weight: 700;
    margin-bottom: 16px;
    //   font-family: Montserrat, Gilroy, Roboto, Product Sans, sans-serif;
    line-height: 1.5;
    text-align: center;
  }
  .about-cont-p2-title {
    color: #3b3844;
    font-size: 22px;
    font-weight: 600;
    margin-bottom: 16px;
    //   font-family: Montserrat, Gilroy, Roboto, Product Sans, sans-serif;
    line-height: 1.5;
    text-align: center;
  }
  .about-cont-title {
    //   text-align: center;
    color: #3b3844;
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 16px;
    //   font-family: Montserrat, Gilroy, Roboto, Product Sans, sans-serif;
    line-height: 1.5;
  }
  .about-cont-main {
    color: #3b3844;
    //   font-family: Montserrat, Gilroy, Roboto, Product Sans, sans-serif;
    font-weight: 400;
    line-height: 1.5;
    font-size: 16px;
    padding-bottom: 16px;
    box-sizing: border-box;
    li {
      line-height: 1.5;
      margin-bottom: 10px;
    }
    a {
      word-break: break-all;
      &:hover {
        color: #f48c06;
      }
    }
  }
}
</style>